.wrapper {
  border-radius: 12px;
  background: #f7f6ff;
  position: relative;
  padding: 10px;
  padding-bottom: 36px;
}

.content {
  font-size: 0px !important;

  ol > li,
  ul > li {
    font-size: 16px;
  }
}
